import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";
import ContratacionesService from "../../services/ContratacionesService";
import { handleErrorApi } from "../../helpers/randoms";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

export const getCartillaPrestadores =
  (idEfectorFacturacion, textoBuscado = "") => async (dispatch) => {
    try {
      const response = await ContratacionesService.traerPrestadores(
        idEfectorFacturacion,
        textoBuscado
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.contratacionesTraerCartillaPrestadoresSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.contratacionesTraerCartillaPrestadoresError });
      handleErrorApi(
        dispatch,
        error,
        "Error al traer los prestadores de cartilla",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const contratacionesCartillaPrestadoresDelete = (idPrestador) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner())
      const { dataContrato } = getState().contrataciones;
      let response = null;
      response = await ContratacionesService.borrarCartillaPrestador(
        idPrestador
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(getCartillaPrestadores(dataContrato.idEfectorFacturacion));
        dispatch(finishSpinner())
        dispatch(
          startAlerta(
            "Prestador Borrado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        dispatch(startAlerta(response.errores, "error", "Error"));
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner())
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar un prestador",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const contratacionesPrestadorSave = (
  dataPrestador
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      dataPrestador.idEfectorFacturacion =
        dataContrato.idEfectorFacturacion;
      let response = null;
      if (dataPrestador.idPrestador === null) {
        response = await ContratacionesService.guardarPrestador(
          dataPrestador
        );
      } else {
        response = await ContratacionesService.actualizarPrestador(
          dataPrestador.idPrestador,
          dataPrestador
        );
      }
      const body = await response.json();
      if (response.ok) {
        dispatch(
          getCartillaPrestadores(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
        if (dataPrestador.idPrestador === null) {
          dispatch(
            startAlerta(
              "Prestador Guardado Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        } else {
          dispatch(
            startAlerta(
              "Prestador Editado Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        }
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar un Prestador",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const contratacionesPrestadoresDelete = (idPrestador) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const { dataContrato } = getState().contrataciones;
      let response = null;
      response = await ContratacionesService.borrarPrestador(
        idPrestador
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(finishSpinner());

        dispatch(getCartillaPrestadores(dataContrato.idEfectorFacturacion));
        dispatch(
          startAlerta(
            "Prestador Borrado Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        dispatch(startAlerta(response.errores, "error", "Error"));
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());

      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar un prestador",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const contratacionesPrestadoresDeleteAll = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());

      const { dataContrato } = getState().contrataciones;
      let response = null;
      response = await ContratacionesService.borrarTodosPrestadores(
        dataContrato.idEfectorFacturacion
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(finishSpinner());

        dispatch(getCartillaPrestadores(dataContrato.idEfectorFacturacion));
        dispatch(
          startAlerta(
            "Prestadores Borrados Exitosamente",
            "success",
            "Comando Exitoso"
          )
        );
      } else {
        dispatch(startAlerta(response.errores, "error", "Error"));
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());

      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar todos los prestadores",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const contratacionesCartillaPrestadoresSave = (
  dataCartillaPrestador
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      const { dataContrato } = getState().contrataciones;
      let response = null;
      if (dataCartillaPrestador.idCartillaPrestadores === null) {
        response = await ContratacionesService.guardarCartillaPrestador(
          dataCartillaPrestador
        );
      } else {
        response = await ContratacionesService.actualizarCartillaPrestador(
          dataCartillaPrestador.idCartillaPrestadores,
          dataCartillaPrestador
        );
      }
      const body = await response.json();
      if (response.ok) {
        dispatch(
          getCartillaPrestadores(dataContrato.idEfectorFacturacion)
        );
        dispatch(finishSpinner());
        if (dataCartillaPrestador.idCartillaPrestadores === null) {
          dispatch(
            startAlerta(
              "Prestador Guardado Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        } else {
          dispatch(
            startAlerta(
              "Prestador Editado Exitosamente",
              "success",
              "Comando Exitoso"
            )
          );
        }
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al guardar un Prestador",
        "Ha ocurrido un error. Intente nuevamente"
      );
      //Esto lo hacemos ya que necesitamos que se muestre el error sin cerrar el modal
      throw Error("Error al guardar un Prestador")
    }
  };
};

export const getCentrosMedicos = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerCentrosMedicos();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetCentrosMedicosSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetCentrosMedicosError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los rubros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getRankingsCartilla = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerRankingsCartilla();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetRankingsCartillaSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetRankingsCartillaError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el ranking cartilla",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getCartilla = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerCartilla();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetCartillaSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetCartillaError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer la cartilla",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getPlanes = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerPlanes();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetPlanesSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetPlanesError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los planes",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getPlanesCuentas = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerPlanesCuentas();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetPlanesCuentasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetPlanesCuentasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los planes",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getCategorias = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerCategorias();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetCategoriasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetCategoriasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los planes",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getRubrosEfector = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerRubros();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetRubrosSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetRubrosError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los rubros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getZonasEfector = () => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerZonas();
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetZonasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetZonasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las zonas",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getZonasEfectorSegunPractica = (codPractica, conInternacion) => async (dispatch) => {
  try {
    const response = await ContratacionesService.traerZonasSegunPractica(codPractica, conInternacion);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.contratacionesGetZonasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.contratacionesGetZonasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las zonas",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const SubirArchivoExcel = (file) => async (dispatch, getState) => {
  dispatch(startSpinner());
  const { dataContrato } = getState().contrataciones;
  const idEfectorFacturacion = dataContrato.idEfectorFacturacion;
  const url = `${baseUrl}/PrestadoresExcel/${idEfectorFacturacion}`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;

  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  }
  const formData = new FormData();
  formData.append("formFile", file);
  try {
    const result = await fetch(url, {
      method: "POST",
      body: formData,
      headers: httpHeaders,
    });

    const body = await result.json();
    if (result.ok) {
      dispatch(startAlerta("Plantilla cargada", "success"))
      dispatch(finishSpinner());
      dispatch(getCartillaPrestadores(idEfectorFacturacion))
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const DescargarPlantillaExcel = () => async (dispatch, getState) => {
  const { dataContrato } = getState().contrataciones;

  const url = `${process.env.REACT_APP_URL}/public-templates/Planilla-Carga-Cartilla.xls`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;
  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: httpHeaders,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Planilla-Carga-Cartilla-${dataContrato.idEfectorFacturacion}.xls`);
      document.body.appendChild(link);
      link.click();
    });
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

//REPORTES
export const generatePDFCartilla = (idEfectorFacturacion) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesService.generarPdfCartilla(idEfectorFacturacion);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      window.open(URL.createObjectURL(body));

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const generateExcelCartilla = (idEfectorFacturacion) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await ContratacionesService.generarExcelCartilla(idEfectorFacturacion);
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());

      let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = `Red - ${idEfectorFacturacion}.xlsx`;
        a.click();

    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el excel",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};
